export const roundToNearest = (input: number): string => {
    const result = Math.round(input);
    return isNaN(result) ? '' : result.toString();
};